import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './EQAPP_Escrow_Release_Package.css';

const EQAPP_Escrow_Release_Package = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"EQAPP_ESCROW_RELEASE_PACKAGE",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	EQAPP_ESCROW_RELEASE_PACKAGE:-1
  });


  const [EQAPP_ESCROW_RELEASE_PACKAGE, setEQAPP_ESCROW_RELEASE_PACKAGE] = React.useState(null);
  const [EQAPP_ESCROW_RELEASE_PACKAGE_D, setEQAPP_ESCROW_RELEASE_PACKAGE_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Equity Appreciation Token Escrow Release Package');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/EQAPP_Escrow_Release_Package',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewEQAPP_ESCROW_RELEASE_PACKAGE(clientInfo,"OpenNew");

		navigate('/EQAPP_Escrow_Release_Package',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Escrow_Release_Package_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewEQAPP_ESCROW_RELEASE_PACKAGE(clientInfo,"OpenNew");
		}
		navigate('/EQAPP_Escrow_Release_Package',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Escrow_Release_Package_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Escrow_Release_Package_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Escrow_Release_Package_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
		if(Temp_Data2.status!="New"){
			handleDeleteEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data2);
			navigate('/EQAPP_Escrow_Release_Package#New',{replace:true});
		} 
		else 
			navigate('/EQAPP_Escrow_Release_Package',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Escrow_Release_Package',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Escrow_Release_Package',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Escrow_Release_Package',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Escrow_Release_Package',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!EQAPP_ESCROW_RELEASE_PACKAGE) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_${i}_SECTION`;
	  const headerId = `#EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [EQAPP_ESCROW_RELEASE_PACKAGE]) ;


  
  
  var Ids = [];
  for(var Ele in EQAPP_ESCROW_RELEASE_PACKAGE){
	  for(var Sec in EQAPP_ESCROW_RELEASE_PACKAGE[Ele]){
		if(Sec == "id")
			Ids.push(EQAPP_ESCROW_RELEASE_PACKAGE[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(EQAPP_ESCROW_RELEASE_PACKAGE[Ele]["status"]);
		else if(Array.isArray(EQAPP_ESCROW_RELEASE_PACKAGE[Ele][Sec]))
			  for(var Row in EQAPP_ESCROW_RELEASE_PACKAGE[Ele][Sec])  // Convert to EQAPP_ESCROW_RELEASE_PACKAGE[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in EQAPP_ESCROW_RELEASE_PACKAGE[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["EQAPP_ESCROW_RELEASE_PACKAGE"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewEQAPP_ESCROW_RELEASE_PACKAGE(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/EQAPP_ESCROW_RELEASE_PACKAGE`).then((response1) => {
		if(!EQAPP_ESCROW_RELEASE_PACKAGE) 
			setEQAPP_ESCROW_RELEASE_PACKAGE(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/EQAPP_ESCROW_RELEASE_PACKAGE_D`).then((response2) => {
			setEQAPP_ESCROW_RELEASE_PACKAGE_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddEQAPP_ESCROW_RELEASE_PACKAGE_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewEQAPP_ESCROW_RELEASE_PACKAGE = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/EQAPP_ESCROW_RELEASE_PACKAGE/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setEQAPP_ESCROW_RELEASE_PACKAGE(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/EQAPP_ESCROW_RELEASE_PACKAGE/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutEQAPP_ESCROW_RELEASE_PACKAGE = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/EQAPP_ESCROW_RELEASE_PACKAGE/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostEQAPP_ESCROW_RELEASE_PACKAGE = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/EQAPP_ESCROW_RELEASE_PACKAGE', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteEQAPP_ESCROW_RELEASE_PACKAGE = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/EQAPP_ESCROW_RELEASE_PACKAGE', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
	Temp_Data["1"]["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_0"]=value;
	//handleAddEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['EQAPP_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("1","EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_0",value,Temp_Data);
 	//handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
	Temp_Data["1"]["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_1"]=value;
	//handleAddEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['EQAPP_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("1","EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_1",value,Temp_Data);
 	//handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
	Temp_Data["1"]["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_2"]=value;
	//handleAddEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['EQAPP_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("1","EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_2",value,Temp_Data);
 	//handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
	Temp_Data["1"]["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_3"]=value;
	//handleAddEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['EQAPP_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("1","EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_3",value,Temp_Data);
 	//handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
	Temp_Data["2"]["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_2_0"]=value;
	//handleAddEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['EQAPP_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("2","EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_2_0",value,Temp_Data);
 	//handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
	Temp_Data["2"]["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_2_1"]=value;
	//handleAddEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['EQAPP_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("2","EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_2_1",value,Temp_Data);
 	//handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
  
      
const EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_3_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
	Temp_Data["3"]["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_3_0"]=value ? true : false; // optionally just use boolean
	//handleAddEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['EQAPP_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("3","EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_3_0",value,Temp_Data);
 	//handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  


  
      
const EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_3_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
	Temp_Data["3"]["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_3_1"]=value ? true : false; // optionally just use boolean
	//handleAddEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['EQAPP_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("3","EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_3_1",value,Temp_Data);
 	//handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  


    
const EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
	Temp_Data["4"]["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_4_0"]=value;
	//handleAddEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['EQAPP_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("4","EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_4_0",value,Temp_Data);
 	//handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  

const EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
	Temp_Data["4"]["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_4_1"]=value;
	Form_Data_onChange("4","EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_4_1",value,Temp_Data);
 	//handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
	//handleAddEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['EQAPP_ESCROW_RELEASE_PACKAGE']);
  }; 
  

    
const EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
	Temp_Data["5"]["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_0"]=value;
	//handleAddEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['EQAPP_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("5","EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_0",value,Temp_Data);
 	//handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
	Temp_Data["5"]["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_1"]=value;
	//handleAddEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['EQAPP_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("5","EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_1",value,Temp_Data);
 	//handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
	Temp_Data["5"]["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_2"]=value;
	//handleAddEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['EQAPP_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("5","EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_2",value,Temp_Data);
 	//handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
	Temp_Data["5"]["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_3"]=value;
	//handleAddEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['EQAPP_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("5","EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_3",value,Temp_Data);
 	//handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  

const EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
	Temp_Data["5"]["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_4"]=value;
	Form_Data_onChange("5","EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_4",value,Temp_Data);
 	//handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
	//handleAddEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['EQAPP_ESCROW_RELEASE_PACKAGE']);
  }; 
  

    
const EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
	Temp_Data["5"]["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_5"]=value;
	//handleAddEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['EQAPP_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("5","EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_5",value,Temp_Data);
 	//handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  

const EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
	Temp_Data["9"]["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_0"]=value;
	Form_Data_onChange("9","EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_0",value,Temp_Data);
 	//handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
	//handleAddEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['EQAPP_ESCROW_RELEASE_PACKAGE']);
  }; 
  

    
const EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
	Temp_Data["9"]["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_1"]=value;
	//handleAddEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['EQAPP_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("9","EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_1",value,Temp_Data);
 	//handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
	Temp_Data["9"]["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_2"]=value;
	//handleAddEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['EQAPP_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("9","EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_2",value,Temp_Data);
 	//handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
	Temp_Data["9"]["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_3"]=value;
	//handleAddEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['EQAPP_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("9","EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_3",value,Temp_Data);
 	//handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
	Temp_Data["9"]["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_4"]=value;
	//handleAddEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['EQAPP_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("9","EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_4",value,Temp_Data);
 	//handleLastDataEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setEQAPP_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!EQAPP_ESCROW_RELEASE_PACKAGE) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedEQAPP_ESCROW_RELEASE_PACKAGE =JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
  updatedEQAPP_ESCROW_RELEASE_PACKAGE[Sec] = [...updatedEQAPP_ESCROW_RELEASE_PACKAGE[Sec], newRow];
  setEQAPP_ESCROW_RELEASE_PACKAGE(updatedEQAPP_ESCROW_RELEASE_PACKAGE);
};

const handleDeleteRow = (sec,index) => {
  const updatedEQAPP_ESCROW_RELEASE_PACKAGE = JSON.parse(JSON.stringify(EQAPP_ESCROW_RELEASE_PACKAGE));
  updatedEQAPP_ESCROW_RELEASE_PACKAGE[sec].splice(index, 1);
  setEQAPP_ESCROW_RELEASE_PACKAGE(updatedEQAPP_ESCROW_RELEASE_PACKAGE);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Equity Appreciation Token Escrow Release Package`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Equity Appreciation Token Escrow Release Package ID`)} <span className="toggle-icon">^</span></h2>
            <div id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`EQAPP Escrow Release Package ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_0" type="text" className="form-control" placeholder="EQAPP Escrow Release Package ID" value={EQAPP_ESCROW_RELEASE_PACKAGE["1"][`EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_0`]} 
						onChange={EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter EQAPP Escrow Release Package ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_1" type="text" className="form-control" placeholder="Offering ID" value={EQAPP_ESCROW_RELEASE_PACKAGE["1"][`EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_1`]} 
						onChange={EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Milestone ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_2" type="text" className="form-control" placeholder="Milestone ID" value={EQAPP_ESCROW_RELEASE_PACKAGE["1"][`EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_2`]} 
						onChange={EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Milestone ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Inspection Report ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_3" type="text" className="form-control" placeholder="Inspection Report ID" value={EQAPP_ESCROW_RELEASE_PACKAGE["1"][`EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_3`]} 
						onChange={EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Inspection Report ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Requested Release Amount USD`)} <span className="toggle-icon">^</span></h2>
            <div id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Requested Release Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_2_0" type="text" className="form-control" placeholder="Requested Release Amount USD" value={EQAPP_ESCROW_RELEASE_PACKAGE["2"][`EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_2_0`]} 
						onChange={EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Requested Release Amount USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approved Release Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_2_1" type="text" className="form-control" placeholder="Approved Release Amount USD" value={EQAPP_ESCROW_RELEASE_PACKAGE["2"][`EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_2_1`]} 
						onChange={EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Approved Release Amount USD`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Lien Waivers Complete`)} <span className="toggle-icon">^</span></h2>
            <div id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_3_SECTION" className="row">
			                 {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_3_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Lien Waivers Complete`)} <input id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_3_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_3_0_Change} 
					  checked={EQAPP_ESCROW_RELEASE_PACKAGE?.["3"]?.["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_3_0"] === "true" || EQAPP_ESCROW_RELEASE_PACKAGE?.["3"]?.["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_3_0"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_3_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Budget Variance Acceptable`)} <input id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_3_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_3_1_Change} 
					  checked={EQAPP_ESCROW_RELEASE_PACKAGE?.["3"]?.["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_3_1"] === "true" || EQAPP_ESCROW_RELEASE_PACKAGE?.["3"]?.["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_3_1"] === true} />
					</label>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Investor Notice Link`)} <span className="toggle-icon">^</span></h2>
            <div id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_4_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Investor Notice Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_4_0" type="text" className="form-control" placeholder="Investor Notice Link" value={EQAPP_ESCROW_RELEASE_PACKAGE["4"][`EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_4_0`]} 
						onChange={EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Investor Notice Link`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Release Recommendation`)}
					 </div>
                     <div className="card-body" >
                        <select id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_4_1"  value={EQAPP_ESCROW_RELEASE_PACKAGE["4"][`EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_4_1`]} onChange={EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_4_1_Change} className="form-control" name="Release Recommendation"  >
						  <option value="Release Full Amount">Release Full Amount</option>
						  <option value="Release Partial Amount">Release Partial Amount</option>
						  <option value="Hold Funds">Hold Funds</option>
						  <option value="Reject Release">Reject Release</option>
						  <option value="Escalate">Escalate</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Release Recommendation
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_0" type="text" className="form-control" placeholder="Submitted By" value={EQAPP_ESCROW_RELEASE_PACKAGE["5"][`EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_0`]} 
						onChange={EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_1" type="text" className="form-control" placeholder="Submitted At" value={EQAPP_ESCROW_RELEASE_PACKAGE["5"][`EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_1`]} 
						onChange={EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_2" type="text" className="form-control" placeholder="Reviewed By" value={EQAPP_ESCROW_RELEASE_PACKAGE["5"][`EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_2`]} 
						onChange={EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_3" type="text" className="form-control" placeholder="Reviewed At" value={EQAPP_ESCROW_RELEASE_PACKAGE["5"][`EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_3`]} 
						onChange={EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_4"  value={EQAPP_ESCROW_RELEASE_PACKAGE["5"][`EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_4`]} onChange={EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_5" type="text" className="form-control" placeholder="Approval Notes" value={EQAPP_ESCROW_RELEASE_PACKAGE["5"][`EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_5`]} 
						onChange={EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_0"  value={EQAPP_ESCROW_RELEASE_PACKAGE["9"][`EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_0`]} onChange={EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_1" type="text" className="form-control" placeholder="Created By" value={EQAPP_ESCROW_RELEASE_PACKAGE["9"][`EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_1`]} 
						onChange={EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_2" type="text" className="form-control" placeholder="Created At" value={EQAPP_ESCROW_RELEASE_PACKAGE["9"][`EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_2`]} 
						onChange={EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_3" type="text" className="form-control" placeholder="Updated By" value={EQAPP_ESCROW_RELEASE_PACKAGE["9"][`EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_3`]} 
						onChange={EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_4" type="text" className="form-control" placeholder="Updated At" value={EQAPP_ESCROW_RELEASE_PACKAGE["9"][`EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_4`]} 
						onChange={EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_05_FINANCE_ESCROW_APPRECIATION_DISTRIBUTION_EQAPP_ESCROW_RELEASE_PACKAGE_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default EQAPP_Escrow_Release_Package;  